import RegionSelector from '@stories/Components/Misc/RegionSelector/RegionSelector';
import * as React from 'react';
import S from './AnnouncementBar.styles';
const AnnouncementBar = (props) => {
    return (React.createElement(S.Container, { "data-variant": props.announcementVariant ?? 'blue', flush: "both", skipLinkType: "header", translations: props.translations },
        props.announcement && (React.createElement(S.Announcement, { role: "alert" },
            props.announcement.text,
            props.announcement.cta && (React.createElement(React.Fragment, null,
                ' ',
                React.createElement("a", { href: props.announcement.cta.url, target: props.announcement.cta.target }, props.announcement.cta.text))))),
        React.createElement(AnnouncementCtas, { ...props, regionSelector: { ...props.regionSelector, idPrefix: 'announcement-bar' } })));
};
export const AnnouncementCtas = (props) => {
    return (React.createElement(S.CtaWrapper, null,
        React.createElement(RegionSelector, { ...props.regionSelector }),
        props.contactCta && (React.createElement("a", { href: props.contactCta.url, target: props.contactCta.target }, props.contactCta.text))));
};
export default AnnouncementBar;
